/**
 * Which build this tab is running.
 *
 * `scripts/write-build-info.mjs` stamps `dist/BUILD_INFO.json` with the commit the bundle was built from,
 * so the deployed console can say what it is. Until it could, "is his tab on the new bundle?" was answered
 * by opening DevTools and matching the `index-<hash>.js` the document references against the hash in the
 * deployed `index.html` — archaeology, in the middle of debugging something else.
 *
 * A dev server has no `dist`, so there is nothing to report and nothing is shown. That is the honest
 * answer: an unbuilt console is not running a published commit.
 */
export function shortCommit(value: unknown): string {
  return typeof value === 'string' && /^[0-9a-f]{40}$/.test(value) ? value.slice(0, 7) : '';
}

export async function loadBuildCommit(): Promise<string> {
  try {
    const response = await fetch('/BUILD_INFO.json', { cache: 'no-store' });
    if (!response.ok) return '';
    const info = await response.json() as { webSourceCommit?: unknown };
    return shortCommit(info.webSourceCommit);
  } catch {
    return '';
  }
}
